/**
 * Period Mode Types for Analyst Bench
 *
 * Controls how financial data is displayed:
 * - annual: Last 5 December periods (5 columns)
 * - quarterly: Last 8 quarters (8 columns)
 * - monthly: Last 12 months (12 columns)
 */

export type PeriodMode = 'annual' | 'quarterly' | 'monthly';

export interface PeriodModeConfig {
  mode: PeriodMode;
  /** i18n translation key for the label */
  label: string;
  maxPeriods: number;
  /** i18n translation key for the description */
  description: string;
}

export const PERIOD_MODE_CONFIG: Record<PeriodMode, PeriodModeConfig> = {
  annual: {
    mode: 'annual',
    label: 'period.annual',
    maxPeriods: 5,
    description: 'period.annualDesc',
  },
  quarterly: {
    mode: 'quarterly',
    label: 'period.quarterly',
    maxPeriods: 8,
    description: 'period.quarterlyDesc',
  },
  monthly: {
    mode: 'monthly',
    label: 'period.monthly',
    maxPeriods: 12,
    description: 'period.monthlyDesc',
  },
};

export const PERIOD_MODES: PeriodMode[] = ['annual', 'quarterly', 'monthly'];
